<template>
  <div>
    <a-page-header title="Subscription Addons">
      <template slot="extra">
        <a-button key="1" type="primary" @click="addNewAddon()">
          Add New Addon
        </a-button>
      </template>
    </a-page-header>
    <data-table
      :columns="columns"
      :data-source="addonsState.addonsList"
      :loading="loading"
      @refreshData="fetchData"
      rowKey="id"
    >
      <span slot="isActive" slot-scope="record">
        <a-tag :color="record.isActive ? 'green' : 'volcano'">
          {{ record.isActive ? "ACTIVE" : "DISABLED" }}
        </a-tag>
      </span>

      <currency-column
        slot="unitPrice"
        slot-scope="record"
        v-model="record.unitPrice"
      />

      <currency-column
        slot="addonBillingTypeName"
        slot-scope="record"
        v-model="record.addonBillingTypeName"
      />
      <currency-column
        slot="displayUnitName"
        slot-scope="record"
        v-model="record.displayUnitName"
      />
      <currency-column
        slot="calculateUnitName"
        slot-scope="record"
        v-model="record.calculateUnitName"
      />

      <date-time-column
        slot="creationDate"
        slot-scope="record"
        v-model="record.creationDate"
      />

      <span slot="action" slot-scope="record">
        <a class="edit-icon" @click="showEditModal(record.id)">
          <a-icon type="edit" />
        </a>
        <a-divider type="vertical" />
        <a class="trash-icon" @click="showDeleteConfirmation(record.id)">
          <a-icon type="delete" />
        </a>
      </span>
    </data-table>
    <EditAddonModal
      v-model="isModalVisible"
      :addon="editedAddon"
      :mode="modalMode"
      :businesses="businesses"
      :addonBillingTypes="addonBillingTypes"
      :units="units"
    ></EditAddonModal>
    <a-modal
      :title="`Are you sure to delete ${deletedAddon.name} permanently?`"
      :visible="showDeleteModal"
    >
      <p>Please type '{{ deletedAddon.name }}' below to proceed the action.</p>
      <a-row>
        <a-col :span="12">
          <a-form-item label="Addon name:">
            <a-input
              v-model="deletedAddonName"
              placeholder="please input addon name"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <template slot="footer">
        <a-tooltip
          :title="
            !deletedAddonName || deletedAddonName !== deletedAddon.name
              ? 'please input addon name'
              : ''
          "
        >
          <a-button
            key="submit"
            :loading="loading"
            :disabled="
              !deletedAddonName || deletedAddonName !== deletedAddon.name
            "
            type="danger"
            @click="confirmDelete"
          >
            Confirm
          </a-button>
        </a-tooltip>
        <a-button key="back" @click="cancel"> Cancel </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import {
  addonsState,
  addonsMutations,
  businessState,
  businessMutations,
  lookupState,
  lookupMutations,
} from "../../Store/store";
import EditAddonModal from "./EditAddonModal";

const columns = [
  {
    title: "Id",
    dataIndex: "id",
    key: "id",
    sorter: true,
    width: 250,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
    width: 250,
  },
  {
    title: "Unit Price",
    key: "unitPrice",
    dataIndex: "unitPrice",
    sorter: true,
  },
  {
    title: "Billing Type",
    key: "addonBillingTypeName",
    dataIndex: "addonBillingTypeName",
    sorter: true,
  },
  {
    title: "Display Unit",
    key: "displayUnitName",
    dataIndex: "displayUnitName",
    sorter: true,
  },  
  {
    title: "Calculate Unit",
    key: "calculateUnitName",
    dataIndex: "calculateUnitName",
    sorter: true,
  },
  {
    title: "Is Active",
    key: "isActive",
    sorter: true,
    scopedSlots: { customRender: "isActive" },
  },
  {
    title: "Actions",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

export default {
  data() {
    return {
      columns,
      isModalVisible: false,
      businesses: [],
      editedAddon: {},
      modalMode: "create",
      addonsState: addonsState,
      loading: false,
      addonBillingTypes: [],
      units: [],
      deletedAddon: {},
      showDeleteModal: false,
      deletedAddonName: null,
    };
  },
  async mounted() {
    await this.fetchData();
    await this.fetchBusinesses();
    await this.fetchAddonBillingTypes();
    await this.fetchUnits();
  },
  methods: {
    async fetchData(params = {}) {
      this.loading = true;
      try {
        await addonsMutations.getAddonsList(params);
      } finally {
        this.loading = false;
      }
    },
    async fetchBusinesses() {
      await businessMutations.setBusinesses();
      this.businesses = businessState.businesses;
    },
    async fetchAddonBillingTypes() {
      await lookupMutations.getAddonBillingTypes();
      this.addonBillingTypes = lookupState.addonBillingTypes;
    },
    async fetchUnits() {
      await lookupMutations.getAllUnits();
      this.units = lookupState.units;
    },
    showDeleteConfirmation(addonId) {
      this.deletedAddon = this.addonsState.addonsList.find(
        (u) => u.id === addonId
      );
      this.showDeleteModal = true;
    },
    async confirmDelete() {
      const self = this;
      self.loading = true;
      try {
        await addonsMutations.deleteAddon(self.deletedAddon.id);
        await self.fetchData();
      } catch (error) {
        self.showError(error);
      } finally{
        self.showDeleteModal= false
        self.deletedAddonName = null
      }
      self.loading = false
    },
    cancel() {
      this.showDeleteModal = false;
      this.deletedAddonName = null;
    },
    addNewAddon() {
      this.modalMode = "create";
      this.editedAddon = {};
      this.isModalVisible = true;
    },
    showEditModal(addonId) {
      this.modalMode = "edit";
      this.editedAddon = {
        ...this.addonsState.addonsList.find((i) => i.id == addonId),
      };
      this.isModalVisible = true;
    },
  },
  components: {
    EditAddonModal,
  },
};
</script>

<style scoped>
.trash-icon:hover {
  color: #bb2020;
}

.edit-icon:hover {
  color: #121317;
}
</style>
